import clsx from 'clsx';
import { FileBadgeIcon, LoaderIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useExportPdf } from '../../hooks/use-export-pdf';
import { Action } from '../action/action';
import styles from './pdf-action.module.css';

export const PDFAction = () => {
	const { t } = useTranslation();
	const { handleExportPDF, isLoading } = useExportPdf();

	return (
		<Action
			tooltip={t('actions.pdf')}
			onClick={handleExportPDF}
			icon={{
				component: isLoading ? LoaderIcon : FileBadgeIcon,
				className: clsx({
					[styles.loading]: isLoading,
				}),
			}}
		/>
	);
};
